(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const galleryItems = document.querySelectorAll('.gallery-item');
  const popup = document.getElementById('galleryPopup');
  const popupImage = document.getElementById('popupImage');
  const closePopup = document.querySelector('.close-popup');
  const prevArrow = document.querySelector('.prev-arrow');
  const nextArrow = document.querySelector('.next-arrow');
  
  let currentIndex = 0;
  const images = Array.from(galleryItems).map(item => ({
    src: item.querySelector('img').dataset.fullSize,
    alt: item.querySelector('img').alt
  }));
  
  // Gallery item click handler
  galleryItems.forEach((item, index) => {
    item.addEventListener('click', function() {
      currentIndex = index;
      openPopup(currentIndex);
    });
  });
  
  // Close popup handler
  closePopup.addEventListener('click', function() {
    popup.style.display = 'none';
  });
  
  // Previous arrow handler
  prevArrow.addEventListener('click', function(e) {
    e.stopPropagation();
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    updatePopupImage(currentIndex);
  });
  
  // Next arrow handler
  nextArrow.addEventListener('click', function(e) {
    e.stopPropagation();
    currentIndex = (currentIndex + 1) % images.length;
    updatePopupImage(currentIndex);
  });
  
  // Close when clicking outside image
  popup.addEventListener('click', function(e) {
    if (e.target === popup) {
      popup.style.display = 'none';
    }
  });
  
  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (popup.style.display === 'block') {
      if (e.key === 'ArrowLeft') {
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        updatePopupImage(currentIndex);
      } else if (e.key === 'ArrowRight') {
        currentIndex = (currentIndex + 1) % images.length;
        updatePopupImage(currentIndex);
      } else if (e.key === 'Escape') {
        popup.style.display = 'none';
      }
    }
  });
  
  function openPopup(index) {
    currentIndex = index;
    popupImage.src = images[index].src;
    popupImage.alt = images[index].alt;
    popup.style.display = 'block';
  }
  
  function updatePopupImage(index) {
    popupImage.src = images[index].src;
    popupImage.alt = images[index].alt;
  }
});

  } catch(e) { console.error(e); }
})();
})();
